import './external/posthog.js'
import './external/openReplay.js'
import {createRoot} from 'react-dom/client'
import './assets/index.css'
import App from './App.jsx'
import {settings} from '@/config/settings.js'
import {BrowserRouter} from 'react-router'

console.log('app:', settings.env.APP_VERSION, 'core:', __APP_PAYMENT_WIDGET_CORE_VERSION__)

createRoot(document.getElementById('root')).render((
  <BrowserRouter>
    <App/>
  </BrowserRouter>
))
